var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgRo = function SvgRo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00319c",
    d: "M0 0h213.333v480H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffde00",
    d: "M213.333 0h213.333v480H213.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M426.666 0H640v480H426.666z"
  }))));
};
export default __webpack_public_path__ + "assets/83853d7f53225c0d8efdb63ce092ad31.svg";
export { SvgRo as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/ro.svg